export default __webpack_public_path__ + "static/media/angle-small-right.90532b2c.svg";